import "core-js/modules/es.array.push.js";
import AgoraRTCClient from '@/assets/js/rtc-client-ng';
import Tool, { addTabTitle, handleLocalStorage, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { controlDeviceBehavior, controlAudio, controlDevicePublish } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
export default {
  data() {
    return {
      showMicMutedInfo: {
        show: false,
        title: 'micMutedInfo.title',
        hideSave: true,
        hideCancel: true,
        showGotIt: true,
        gotIt: 'micMutedInfo.ignore'
      },
      lowNetworkTime: 0,
      lowNetwork: false,
      initAudioOnlyPopup: true,
      freeTalk: false,
      wsPageSTimer: null,
      rtilStatusObj: {},
      showUnread: false,
      allPartyMembers: [],
      lockName: true,
      managerRtils: [],
      pgm: {},
      channels: {},
      rtc: {},
      shareRtc: null,
      isShare: false,
      shareParams: {},
      partyCode: '',
      rtilCode: 0,
      shareInfo: {},
      devicesInfo: {},
      outPutRtilCode: '',
      shareRtilCode: 0,
      realPartyCode: '',
      socket: null,
      micCameraFlag: true,
      MeInfo: {},
      showMe: true,
      showHost: true,
      userInfo: {},
      ckeckStatusTimer: null,
      setNameInfo: {
        show: false
      },
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      joinParam: {},
      behaviorInfo: {},
      hasBeenTalk: false,
      talkStream: null,
      talkInfo: {},
      smallVideoResoution: [192, 108],
      hasSetRaiseHand: false,
      raiseLoading: false,
      receiveAudioPartyList: [],
      receiveAudioArray: {},
      externalParty: {},
      speakerInfo: null,
      broadCast: null,
      sourceType: '',
      controlMutes: {},
      layoutName: '',
      hasSet: false,
      checkInitAgoraStatusTimer: null,
      CameraTips: {
        hideSave: false,
        hideCancel: false,
        showGotIt: false,
        gotIt: 'galleryParticipant.gotIt',
        title: 'galleryParticipant.cameraTips',
        content: '',
        cancel: 'galleryParticipant.deny',
        save: 'galleryParticipant.admit',
        show: false
      },
      rtcLoaded: false,
      isPhone: false,
      videoMedia: {},
      isFullScreen: false,
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      hadOpenWebCloud: false,
      degreeHost: {},
      voiceList: {},
      localVolume: 0,
      audioLevel: true,
      hostControlPipRtilCode: {},
      hasGetTimeOffset: false,
      bestOffset: 0,
      sendMetadataTimer: null
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      isMute: state => state.isMute,
      Config: state => state.config,
      logoGray: state => state.logoGray,
      loginInfo: state => state.loginInfo
    }),
    operateList() {
      if (this.lockName) {
        return ['fullScreen'];
      } else {
        return ['fullScreen', 'rename'];
      }
    },
    TitleText() {
      let _str = '';
      const broadCastName = this.broadCast ? this.broadCast.nickName : '';
      const speakerName = this.speakerInfo ? this.speakerInfo.nickName : '';

      // 如果broadcast和speaker都有时
      if (broadCastName && speakerName) {
        if (this.broadCast.rtilCode == this.rtilCode) {
          _str = `You are talking with ${speakerName}(Public speaker)`;
        } else if (this.speakerInfo.rtilCode == this.rtilCode) {
          // you are speaker
          _str = `The broadcaster(${broadCastName})` + ' talk with you(Public speaker)';
        } else {
          _str = `The broadcaster(${broadCastName}) talk with ${speakerName}(Public speaker)`;
        }
      }

      // 如果有broadcast没有speaker时
      if (broadCastName && !speakerName) {
        if (this.broadCast.rtilCode == this.rtilCode) {
          _str = this.$t('commonFunction.broadCaster');
        } else {
          _str = `${broadCastName} ` + this.$t('commonFunction.isBroadCaster');
        }
      }
      // 如果有speaker没有broadcast
      if (!broadCastName && speakerName) {
        if (this.speakerInfo.rtilCode == this.rtilCode) {
          _str = this.$t('galleryParticipant.publicSpeaker');
        } else {
          _str = `${speakerName} ` + this.$t('galleryParticipant.nowSpeaker');
        }
      }
      return _str;
    },
    returnVideoClass() {
      let _str = '';
      if (this.degreeHost[this.MeInfo.id] == 0) {
        _str += 'rotate0';
      } else if (this.degreeHost[this.MeInfo.id] == 90) {
        _str += 'rotate90';
      } else if (this.degreeHost[this.MeInfo.id] == 180) {
        _str += 'rotate180';
      } else if (this.degreeHost[this.MeInfo.id] == 270) {
        _str += 'rotate270';
      }
      return _str;
    }
  },
  created() {
    // 记录与会者进入页面方式
    sessionStorage.setItem('enterPartyType', 'web');
    // 清除之前与会者以host的身份登录的登录信息，
    Tool.removeHostLoginInfo();
    if (/Android|webOS|iPad|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || navigator.maxTouchPoints == 5) {
      this.isPhone = true;
    }
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach(volume => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.$route.query.id) return;
      this.pageSerBusCallback(v);
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
    });
    Bus.$off('moveParticipants');
    Bus.$on('moveParticipants', val => {
      if (this.userInfo.joinCode != val.originCode) return; // 如果在move过程中，这个与会者到了别的party。则move的命令此时不作处理
      val.rtilCodes.forEach(v => {
        if (v == this.userInfo.rtilCode) routerJump('participate', {
          join_id: val.targetCode,
          moveParticipants: true
        });
      });
    });
    // host控制与会者是否重命名功能
    Bus.$on('setLoginScreenButton', async val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 4) {
        if (operationType === 0) {
          this.lockName = true;
          this.$message.success(this.$t('remainWords.hostLockParticipantName'));
        } else {
          this.lockName = false;
          this.$message.success(this.$t('remainWords.hostUnlockParticipantName'));
        }
      } else if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave());
          }
          this.joinPartyLine();
        } else {
          this.hadOpenWebCloud = false;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave('closeCLoudProxy'));
          }
          this.joinPartyLine();
        }
      } else if (buttonType === 13) {
        this.$message.warning(this.$t('setting.muteAllParticipantsTips'));
        this.setCameraOrMic('muteAudio', false);
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.audioLevel = true;
        } else {
          this.audioLevel = false;
        }
      }
    });
    Bus.$off('setFreeTalk');
    Bus.$on('setFreeTalk', () => {
      if (this.layoutName == '2-2') {
        this.freeTalk = true;
        const _remotePublishUser = this.rtc[this.realPartyCode]._remotePublishUser;
        Object.keys(_remotePublishUser).forEach(v => {
          this.rtc[this.realPartyCode].subscribe(v, 'all');
        });
      }
    });
    Bus.$off('cancelFreeTalk');
    Bus.$on('cancelFreeTalk', () => {
      this.freeTalk = false;
      // 取消订阅其他与会者的流
      const _remotePublishUser = this.rtc[this.realPartyCode]._remotePublishUser;
      Object.keys(_remotePublishUser).forEach(v => {
        if (!this.managerRtils.includes(v)) {
          this.rtc[this.realPartyCode].unsubscribe(v, 'all');
        }
      });
    });
    const {
      id
    } = this.$route.query;
    this.State.partyCode = id;
    gtag('event', 'pageView-Gallery view participate', {
      event_category: 'pageView',
      event_label: '会议模块',
      value: 'Gallery view participate'
    });
    Bus.$on('cancelScreen', res => {
      this.isShare = false;
      this.shareInfo = {};
    });
    const _self = this;
    Bus.$on('setCrew', v => {
      // 只有是自己的时候才去显示耳机的icon(needRememberInfo用于判断是否显示icon)
      if (v.rtilCode === _self.rtilCode) {
        _self.State.isCrew = true;
      }
    });
    // 取消显示耳机Icon
    Bus.$on('cancelCrew', v => {
      if (v.rtilCode === _self.rtilCode) {
        _self.State.isCrew = false;
      }
    });
    // 接收开启私聊信息
    Bus.$off('startPrivateConversation');
    Bus.$on('startPrivateConversation', v => {
      const {
        crewRtilCode,
        rtilCode
      } = v;
      if (rtilCode === _self.rtilCode) {
        this.$message({
          type: 'success',
          message: this.$t('commonFunction.privateConversation')
        });
        // 如果私聊是自己，需要mute掉没在和自己私聊的host的声音
        this.managerRtils.forEach(id => {
          if (id != crewRtilCode) {
            this.$set(this.controlMutes, id, true);
          } else {
            if (this.State.isMute) {
              this.$set(this.controlMutes, id, true);
            } else {
              this.$set(this.controlMutes, id, false);
            }
          }
        });
        this.State.privateInfo = v;
        this.State.privateInfo.realPartyCode = this.realPartyCode;
      }
      if (rtilCode !== _self.rtilCode) {
        // this.showHost = false
        // 如果不是自己正在私聊，需要mute掉正在私聊的host的声音(目前与会者只能听到host的声音)
        this.$set(this.controlMutes, crewRtilCode, true);
        if (!this.State.privateInfoByOthers.length) {
          this.State.privateInfoByOthers.push(v);
          return;
        }
        if (this.State.privateInfoByOthers.length) {
          this.State.privateInfoByOthers.forEach(val => {
            if (crewRtilCode != val.crewRtilCode || rtilCode != val.rtilCode) {
              this.State.privateInfoByOthers.push(v);
            }
          });
        }
      }
    });
    // 接收取消私聊信息
    Bus.$off('cancelPrivateConversation');
    Bus.$on('cancelPrivateConversation', v => {
      if (v.rtilCode === _self.rtilCode) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.privateConversaitonEnd')
        });
        // 如果私聊是自己，需要恢复没在和自己私聊的host的声音（在私聊的其他host不可以恢复mute）
        const otherPraivateHost = this.State.privateInfoByOthers.map(v => v.crewRtilCode + '');
        this.managerRtils.forEach(id => {
          id = id + '';
          if (!otherPraivateHost.includes(id)) {
            this.$set(this.controlMutes, id, '');
          }
        });
        // 需要取消在 realParty 里面的订阅 host 流
        this.rtc[this.realPartyCode].unsubscribe(this.State.privateInfo.crewRtilCode, 'audio');
        this.State.privateInfo = {};
      }
      if (v.rtilCode != _self.rtilCode) {
        // 如果私聊不是自己，需要恢复刚在私聊的host
        this.State.privateInfoByOthers.forEach((val, index) => {
          if (v.crewRtilCode == val.crewRtilCode && v.rtilCode == val.rtilCode) {
            this.State.privateInfoByOthers.splice(index, 1);
          }
        });
        if (this.State.privateInfo.crewRtilCode) {
          // 如果自己还存在私聊，则还需要继续mute
          this.$set(this.controlMutes, v.rtilCode, true);
          this.$set(this.controlMutes, v.crewRtilCode, true);
        } else {
          // 没有私聊存在，则恢复mute
          this.$set(this.controlMutes, v.rtilCode, '');
          this.$set(this.controlMutes, v.crewRtilCode, '');
        }
      }
    });
    Bus.$on('managerOnline', v => {
      if (!this.managerRtils.includes(v.rtilCode)) {
        this.managerRtils.push(v.rtilCode);
        // 如果私聊是自己，需要mute掉没在和自己私聊的host的声音
        if (this.State.privateInfo.rtilCode == this.userInfo.rtilCode) {
          this.managerRtils.forEach(v => {
            if (v != this.userInfo.rtilCode) {
              this.$set(this.controlMutes, v, true);
            }
          });
        }
        // 如果存在别人在私聊，则需要mute掉私聊的host声音
        if (this.State.privateInfoByOthers.length) {
          this.State.privateInfoByOthers.forEach(v => {
            this.$set(this.controlMutes, v.crewRtilCode, true);
          });
        }
      }
    });
    // 接收group模式下大屏视频的rtilCode
    Bus.$on('setOutput', async v => {
      const {
        sourceType
      } = v;
      this.outPutRtilCode = String(v.rtilCode);
      this.State.outputCode = v.rtilCode;
      if (sourceType === 'Participant') {
        this.broadCast = v.info ? v.info : {
          rtilCode: v.rtilCode,
          nickName: v.nickName
        };
        if (this.broadCast && this.broadCast.rtilCode == this.rtilCode) {
          this.showMe = false;
          if (this.isPhone) {
            this.$message({
              type: 'error',
              message: this.$t('remainWords.supportphoneToBroadcaster')
            });
            return;
          }
          // 当与会者被设置成broadcast的时候要停掉正常cahnnel里面的流改为在特殊的那个channel里面发流
          for (const k in this.rtc) {
            if (k == this.externalParty) {
              setTimeout(() => {
                var _this$rtc$this$extern;
                const setArray = [];
                if (this.userInfo.rtilCode && this.State.cameraStatus[this.userInfo.rtilCode]) {
                  setArray.push('video');
                }
                if (this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode]) {
                  setArray.push('audio');
                }
                (_this$rtc$this$extern = this.rtc[this.externalParty]) === null || _this$rtc$this$extern === void 0 ? void 0 : _this$rtc$this$extern.publish(setArray, info => {
                  const {
                    type
                  } = info;
                  if (type === 'failed') {
                    this.$message.error('Set broadcaster failed, please try refreshing the page to restore the video.');
                  }
                });
              }, 1000);
            } else {
              this.rtc[k].unpublish(['audio', 'video']);
            }
          }
        }
      }
      // pgm的流需要订阅
      const rtilCode = v.rtilCode * 1;
      // effectRtilCodes
      if (sourceType === 'Participant' && this.broadCast.rtilCode == this.rtilCode) {
        this.subscribePgmStream(rtilCode, _self.externalParty, 'setOutput');
      } else {
        const stream = this.rtc[_self.realPartyCode]._remotePublishUser[rtilCode];
        if (stream) {
          this.rtc[_self.realPartyCode].subscribe(rtilCode, 'all');
          this.subscribeRemotePgmStream(rtilCode, stream);
        } else {
          await this.rtc[_self.externalParty].subscribe(rtilCode, 'all');
          const stream = this.rtc[this.externalParty]._remotePublishUser[rtilCode];
          this.subscribeRemotePgmStream(rtilCode, stream);
        }
        this.userInfo.status.outputs.push({
          output: rtilCode,
          outputId: '',
          outputSource: 'Gallery'
        });
      }
      this.getSourceType(sourceType);
    });
    Bus.$on('cancelOutput', v => {
      const {
        sourceType,
        rtilCode
      } = v;
      this.outPutRtilCode = '';
      this.State.outputCode = '';
      this.sourceType = '';
      if (this.freeTalk) {
        return; // 2-2模式下，直接取消，不走后面的逻辑，不可以设置broadca，output rtilCode会leave party
      }

      if (sourceType === 'Participant' || !this.broadCast) {
        this.pgm = {
          clearVideo: true,
          stream: {},
          id: ''
        };
      }
      // 当取消的是broadcast的时候下面逻辑不用走，走rejoin
      if (sourceType === 'Participant' && this.broadCast && this.broadCast.rtilCode == this.rtilCode) {
        this.showMe = true;
        this.broadCast = null;
        return;
      }
      if (sourceType === 'Participant') {
        this.broadCast = null;
      }
      this.userInfo.status.outputs = this.userInfo.status.outputs.filter(item => {
        return item.output != rtilCode;
      });
      // 检测是否还有output输出
      if (sourceType === 'Participant') {
        this.userInfo.status.outputs.forEach((item, index) => {
          const {
            output
          } = item;
          // 根据externalOutput字段来根据不同的channel去去流
          if (this.userInfo.status.externalOutput) {
            const stream = this.rtc[this.externalParty]._remotePublishUser[output];
            this.subscribeRemotePgmStream(output, stream);
          } else {
            const stream = this.rtc[this.realPartyCode]._remotePublishUser[output];
            this.subscribeRemotePgmStream(output, stream);
          }
        });
      }
    });
    // 被调度者移除当前会议
    Bus.$off('removeParticipant');
    Bus.$on('removeParticipant', v => {
      if (v.rtilCode === _self.rtilCode) {
        this.sendLeave();
      }
    });
    // 被替换party 替换的人/被替换的人/以及与会者被移除自动加入的人走的逻辑
    Bus.$on('switchParty', v => {
      let newRealPartyCode = '';
      this.repeatInfo.show = false;
      if (v.realPartyCode == this.realPartyCode) return;
      if (v.originPartyCode == this.realPartyCode && v.rtilCode == this.rtilCode) this.pgm = {};
      // 当前与会者被更改了partyCode
      if (v.rtilCode == _self.rtilCode) {
        newRealPartyCode = v.realPartyCode;
        this.joinPartyLine(newRealPartyCode);
      }
    });
    Bus.$on('rejoin', v => {
      if (v.rtilCode == this.rtilCode) this.joinPartyLine();
    });
    Bus.$on('endParty', v => {
      routerJump('remove', {
        type: 'end'
      });
    });
    Bus.$on('controlBehavior', async v => {
      const {
        rtilCode,
        behavior,
        senderRtilCode
      } = v;
      const {
        key,
        value
      } = behavior;
      if (rtilCode == this.userInfo.rtilCode) {
        if (key == 'camera') {
          if (!this.devicesInfo.cameraId) return;
          this.$set(this.hostControlPipRtilCode, 'camera', senderRtilCode);
          if (value === 'true') {
            this.CameraTips.hideCancel = false;
            this.CameraTips.hideSave = false;
            this.CameraTips.showGotIt = false;
            this.CameraTips.show = true;
            this.CameraTips.content = `<div class="end">${this.$t('galleryParticipant.cameraTipCon')}</div>`;
          } else {
            var _this$rtc$this$realPa, _this$rtc$this$extern2;
            // 主持人关闭与会者摄像头
            (_this$rtc$this$realPa = this.rtc[this.realPartyCode]) === null || _this$rtc$this$realPa === void 0 ? void 0 : _this$rtc$this$realPa.setEnabled(false, 'video');
            (_this$rtc$this$extern2 = this.rtc[this.externalParty]) === null || _this$rtc$this$extern2 === void 0 ? void 0 : _this$rtc$this$extern2.setEnabled(false, 'video');
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, false);
            this.$message.warning(this.$t('commonFunction.hasCameraOff'));
          }
        }
        if (key == 'mic') {
          if (!this.devicesInfo.microphoneId) return;
          this.$set(this.hostControlPipRtilCode, 'mic', senderRtilCode);
          if (value === 'true') {
            const rtc = this.rtc[this.realPartyCode];
            if (rtc && rtc._localAudioTrack) {
              await controlDevicePublish(rtc, 'publish', [rtc._localAudioTrack]);
              if (this.speakerInfo && this.speakerInfo.rtilCode == this.userInfo.rtilCode || this.broadCast && this.broadCast.rtilCode == this.userInfo.rtilCode) {
                if (this.rtc[this.externalParty]) {
                  await controlDevicePublish(this.rtc[this.externalParty], 'publish', [this.rtc[this.externalParty]._localAudioTrack]);
                }
              }
            } else {
              controlAudio(rtc, this.devicesInfo, true, result => {
                if (result == 'failed') operationResult = 'failed';
              });
              if (this.speakerInfo && this.speakerInfo.rtilCode == this.userInfo.rtilCode || this.broadCast && this.broadCast.rtilCode == this.userInfo.rtilCode) {
                controlAudio(rtc, this.devicesInfo, true, result => {});
              }
            }
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
          } else {
            const realPartyCode = this.State.partyJoinInfo.realPartyCode;
            if (this.rtc[realPartyCode]) {
              controlDevicePublish(this.rtc[realPartyCode], 'unpublish', [this.rtc[realPartyCode]._localAudioTrack]);
            }
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
          }
          this.$message.warning(value === 'true' ? this.$t('remainWords.hostHasMicrophoneOn') : this.$t('commonFunction.hasMicrophoneOff'));
        }
      }
      if (key == 'nickName' && this.behaviorInfo[rtilCode]) {
        this.behaviorInfo[rtilCode] = value;
      }
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.behaviorInfo, val.mark, val.value);
          if (val.initiator && val.initiator != this.userInfo.rtilCode && val.mark == this.userInfo.rtilCode) {
            this.$message.success(this.$t('remainWords.hostModifyParticipantName'));
          }
        }
      });
    });
    Bus.$on('denyRaiseHand', v => {
      const {
        rtilCode
      } = v;
      if (rtilCode == this.rtilCode) {
        this.hasSetRaiseHand = false;
      }
    });
    Bus.$on('changeLayout', v => {
      var _this$rtc$this$realPa2, _layoutName$split;
      (_this$rtc$this$realPa2 = this.rtc[this.realPartyCode]._client) === null || _this$rtc$this$realPa2 === void 0 ? void 0 : _this$rtc$this$realPa2.disableDualStream(() => {});
      const {
        layoutName
      } = v;
      if (((_layoutName$split = layoutName.split('-')) === null || _layoutName$split === void 0 ? void 0 : _layoutName$split[0]) >= 6) {
        var _this$rtc$this$realPa3;
        // 开启双流模式
        (_this$rtc$this$realPa3 = this.rtc[this.realPartyCode]._client) === null || _this$rtc$this$realPa3 === void 0 ? void 0 : _this$rtc$this$realPa3.enableDualStream(() => {});
      }
      if (layoutName === '6-6' || layoutName === '7-7') {
        this.setLowStreamParameter({
          width: 192,
          height: 108,
          framerate: 30
        });
      } else if (layoutName === '6-7' || layoutName === '8-8') {
        this.setLowStreamParameter({
          width: 192,
          height: 108,
          framerate: 15
        });
      }
    });
    Bus.$on('setSpeaker', v => {
      this.speakerInfo = v.info;
      if (!this.speakerInfo) return;
      // 当与会者被设置成public speaker的时候要停掉正常 channel 里面的流改为在特殊的那个channel里面发流
      if (this.speakerInfo.rtilCode == this.rtilCode) {
        for (const k in this.rtc) {
          if (k == this.externalParty) {
            // 和设置broadcaster一样怕两个channel之间有影响
            setTimeout(() => {
              var _this$rtc$this$extern3;
              (_this$rtc$this$extern3 = this.rtc[this.externalParty]) === null || _this$rtc$this$extern3 === void 0 ? void 0 : _this$rtc$this$extern3.publish(['audio', 'video']);
            }, 1000);
          } else {
            this.rtc[k].unpublish(['audio', 'video']);
          }
        }
      }
    });
    Bus.$on('cancelSpeaker', v => {
      this.speakerInfo = null;
    });
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status
      } = result;
      if (collaborateUserId == this.State.loginInfo.id) {
        status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
        if (status === 0) {
          this.collaborateInfo.info = result;
        } else if (status === 2) {
          this.collaborateInfo.info = {};
        }
      }
    });
    Bus.$on('flipVideo', v => {
      // 与会者getList(Host、anywhere)
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    // 处理audioOnly
    Bus.$on('subscribeAudioControl', val => {
      if (val) {
        // 2禁用
        if (val == 2) {
          // 处理mainWindow初始化&&分享屏幕
          if (this.outPutRtilCode && this.pgm.hasUnsubscribe) {
            this.pgm.hasUnsubscribe = false;
            this.rtc[this.externalParty].subscribe(this.pgm.id, 'video', 'unExecuteCallback');
          }
          return;
          // 2 是关闭 audio-only 状态不用订阅
        }

        if (val == 1 && this.outPutRtilCode && !this.pgm.hasUnsubscribe) {
          this.pgm.hasUnsubscribe = true;
          this.$delete(this.pgm, 'videoTrack');
          this.rtc[this.externalParty].unsubscribe(this.pgm.id, 'video', 'unExecuteCallback');
        }
      } else {
        // 0 自动状态
        // mainWindow 特殊处理
        if (this.outPutRtilCode && this.pgm.hasUnsubscribe) {
          this.pgm.hasUnsubscribe = false;
          this.rtc[this.externalParty].subscribe(this.pgm.id, 'video', 'unExecuteCallback');
        }
      }
    });
    // 网络状态与audioOnly
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          if (this.outPutRtilCode) {
            this.pgm.hasUnsubscribe = false;
            this.rtc[this.externalParty].subscribe(this.pgm.id, 'video', 'unExecuteCallback');
          }
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          if (this.outPutRtilCode && !this.pgm.hasUnsubscribe) {
            this.pgm.hasUnsubscribe = true;
            this.$delete(this.pgm, 'videoTrack');
            this.rtc[this.externalParty].unsubscribe(this.pgm.id, 'video', 'unExecuteCallback');
          }
          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
  },
  methods: {
    openMicMuted() {
      window.open('ms-settings:sound', '_blank');
    },
    // 处理初始化及其他 audio-only 时的视频订阅问题
    dealSubscribeVideo(payload) {
      const {
        id
      } = payload;
      // 因为还没有后面赋值所以先添加上
      if (!this.channels[id]) {
        this.$set(this.channels, id, {
          id: id
        });
      }
      // 处理mainWindow初始化&&分享屏幕
      if (this.outPutRtilCode && this.outPutRtilCode == id) {
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.pgm.hasUnsubscribe = false;
            this.rtc[this.externalParty].subscribe(id, 'video', 'unExecuteCallback');
          } else {
            this.pgm.hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            this.pgm.hasUnsubscribe = true;
          } else {
            this.pgm.hasUnsubscribe = false;
            this.rtc[this.externalParty].subscribe(id, 'video', 'unExecuteCallback');
          }
        }
      }
    },
    sendLeave() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'leaveParty',
        msg: {
          rtilCode: this.userInfo.rtilCode,
          realPartyCode: this.realPartyCode,
          externalParty: this.externalParty
        }
      };
      if (!params.partyCode || !params.msg.rtilCode) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=11260', params).then(res => {
        this.$message({
          type: 'info',
          message: this.$t('commonFunction.someOneRemoveYou')
        });
        this.rtc[this.realPartyCode].leave();
        routerJump('remove');
      });
    },
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.optionType == 1) {
            this.$message.success(this.$t('personalInfo.acceptSuccess'));
          } else {
            this.$message.success(this.$t('personalInfo.acceptCancel'));
          }
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    dealFootEvent(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'muteVideo':
        case 'muteAudio':
          this.setCameraOrMic(type, val);
          break;
        case 'changeDevice':
          this.changeDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
        case 'showChat':
          this.State.showChatMessage = val;
          break;
        case 'raiseHand':
          this.setRaiseHand();
          break;
        case 'leave':
          Bus.$emit('showDialog', {
            show: true,
            realPartyCode: this.partyCode,
            externalParty: this.externalParty,
            rtilCode: this.userInfo.rtilCode
          });
          break;
      }
    },
    // 新SDK的方法
    remoteStreamAdded({
      id,
      remoteUser,
      channel,
      type
    }) {
      if (id == this.outPutRtilCode || channel != this.realPartyCode) return;
      // host默认不发流，只有host在realParty里面跟自己私聊的时候才发流
      if (this.freeTalk) {
        if (!this.managerRtils.includes(id)) {
          this.rtc[this.realPartyCode].subscribe(id, type);
        }
      }
      // 如果 host 和自己私聊需要在 realParty 里面订阅 host的流
      if (this.State.privateInfo.rtilCode && this.State.privateInfo.rtilCode == this.userInfo.rtilCode) {
        this.rtc[this.realPartyCode].subscribe(this.State.privateInfo.crewRtilCode, 'audio');
      }
    },
    getSourceType(type) {
      if (!type) return '';
      switch (type) {
        case 'ShareScreen':
          this.sourceType = 'Share';
          break;
        case 'Participant':
          this.sourceType = 'Broadcaster';
          break;
        default:
          this.sourceType = 'VFB';
          break;
      }
    },
    muteAudioOrVideo(action, payload) {
      const {
        id,
        mediaType
      } = payload;
      if (action === 'user-published') {
        if (mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, true);
        } else {
          this.$set(this.State.micStatus, id, true);
        }
      } else {
        if (mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, false);
        } else {
          this.$set(this.State.micStatus, id, false);
        }
      }
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        const rtilCodes = [this.userInfo.rtilCode];
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: rtilCodes,
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket && socket.client.readyState === 1 && rtilCodes.length && partyCode == this.$route.query.id) {
          socket.send(params);
        }
      }, 1000);
    },
    chatCallback({
      type,
      rtilCode,
      data
    }) {
      if (type == 'nickName') {
        this.getNickName(rtilCode);
      }
      if (type == 'getAllMembers') {
        this.getAllMembers();
      }
      if (type == 'unreadInfo') {
        this.showUnread = false;
        Object.keys(data).forEach(keys => {
          if (data[keys].unRead) {
            this.showUnread = true;
          }
        });
      }
    },
    getAllMembers() {
      if (!this.$route.query.id) return;
      this.axios.get(`/partyline-backend/party/noLogin/onlineMembers/${this.$route.query.id}`).then(res => {
        if (res.data.errorCode == '0x0') {
          const number = res.data.result;
          this.allPartyMembers = [];
          Object.keys(number).forEach(v => {
            const rtilCodes = number[v].map(val => val.rtilCode);
            this.allPartyMembers = this.allPartyMembers.concat(rtilCodes);
          });
        }
      });
    },
    getNickName(id) {
      if (!this.$route.query.id) return;
      this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.$route.query.id,
        keys: ['nickName', 'flipVideo'],
        marks: [id]
      }).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result[id];
          this.$set(this.degreeHost, id, result.flipVideo);
          if (this.userInfo.managerRtils.includes(id)) {
            this.userInfo.managerRtils.sort((a, b) => {
              return b - a;
            });
            const hostIndex = this.userInfo.managerRtils.findIndex(item => {
              return item === id;
            });
            result.nickName = 'host' + (hostIndex + 1);
          }
          this.$set(this.behaviorInfo, id, result.nickName);
        }
      });
    },
    // 切换媒体输入设备
    changeDevice(obj) {
      if (obj.type == 'speaker') {
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // mainWindow切换
        if (this.outputRtilCode && this.$refs.mainwindowBox) {
          this.$refs.mainwindowBox.setSpeakerAttendUser();
        }
        // host切换
        this.$nextTick(() => {
          var _this$$refs$remoteHos;
          ((_this$$refs$remoteHos = this.$refs.remoteHost) === null || _this$$refs$remoteHos === void 0 ? void 0 : _this$$refs$remoteHos[0]) && this.$refs.remoteHost[0].setSpeakerAttendUser();
        });
      }
      if (!this.isPhone) {
        Object.keys(this.rtc).forEach(key => {
          this.rtc[key] && this.rtc[key].setDevice(obj.deviceId, obj.type, result => {
            if (obj.type == 'audio' && result === 'success') {
              var _this$$refs$localAtte;
              (_this$$refs$localAtte = this.$refs.localAttentUser) === null || _this$$refs$localAtte === void 0 ? void 0 : _this$$refs$localAtte.reAddAudioContext();
            }
          });
        });
      }
    },
    // 允许主持人操作摄像头
    setCameraStatus(val) {
      this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].setEnabled(true, 'video');
      this.rtc[this.externalParty] && this.rtc[this.externalParty].setEnabled(true, 'video');
      this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
    },
    // 拒绝主持人操作摄像头
    sendToHost() {
      const params = {
        module: 'responseControlBehavior',
        partyCode: this.State.partyCode,
        origin: 'galleryviewParticipate',
        msg: {
          key: 'camera',
          senderRtilCode: this.userInfo.rtilCode,
          rtilCode: this.hostControlPipRtilCode.camera,
          responseCode: 2
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=30228', params);
    },
    returnVal(pgm) {
      let muteVoice = '';
      if (!pgm) return muteVoice;
      // 当有broadcast并且broadcast是自己的时候是不需要听声音的
      if (this.broadCast && this.broadCast.rtilCode == this.rtilCode) {
        muteVoice = true;
      }
      return muteVoice;
    },
    attendCallback({
      type,
      val
    }) {
      if (type == 'muteAudio' || type == 'muteVideo') {
        this.setCameraOrMic(type, val);
      }
      if (type === 'fullScreen') {
        this.isFullScreen = val;
        this.State.fullScreen = val;
        if (val && getFullscreenEnabled()) {
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      }
      if (type === 'audioContext') {
        this.localVolume = val;
      }
    },
    setRaiseHand() {
      // 先判断当前是否是crew或者正在被私聊
      if (this.State.isCrew) {
        this.$message({
          type: 'warning',
          message: this.$t('commonFunction.crewTips')
        });
        return;
      }
      if (JSON.stringify(this.State.privateInfo) != '{}' && this.State.privateInfo.rtilCode == this.rtilCode) {
        this.$message({
          type: 'warning',
          message: this.$t('commonFunction.privateMessage')
        });
        return;
      }
      if (this.broadCast && this.broadCast.rtilCode == this.rtilCode) {
        this.$message({
          type: 'warning',
          message: this.$t('commonFunction.operateBroadcaster')
        });
        return;
      }
      if (this.speakerInfo && this.speakerInfo.rtilCode == this.rtilCode) {
        this.$message({
          type: 'warning',
          message: this.$t('commonFunction.operatePublicSpeaker')
        });
        return;
      }
      const params = {
        partyCode: this.State.partyCode,
        module: this.hasSetRaiseHand ? 'denyRaiseHand' : 'raiseHand',
        msg: {
          name: this.behaviorInfo[this.MeInfo.id],
          rtilCode: this.rtilCode,
          groupId: this.State.partyCode,
          realPartyCode: this.realPartyCode
        }
      };
      this.hasSetRaiseHand = true;
      if (this.raiseLoading) return;
      this.raiseLoading = true;
      this.axios.post('/partyline-backend/party/noLogin/command?key=45194', params).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          if (params.module === 'raiseHand') {
            this.$message({
              type: 'success',
              message: this.$t('galleryParticipant.sendChatRequst')
            });
          } else {
            this.$message({
              type: 'success',
              message: this.$t('galleryParticipant.removeChatRequest')
            });
          }
        } else {
          this.hasSetRaiseHand = false;
        }
        this.raiseLoading = false;
      });
    },
    setNickName(obj) {
      // 只有设置了nickname才可以join到会议
      this.joinRequest('', obj);
    },
    checkStatus() {
      this.axios.get(`/partyline-backend/party/noLogin/status/${this.State.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          if (this.State.pageSerBusRequestWs[this.State.partyCode]) {
            if (this.State.pageSerBusRequestWs[this.State.partyCode].client && this.State.pageSerBusRequestWs[this.State.partyCode].client.readyState === 1) {
              const shareScreen = res.data.result.shareScreen ? JSON.parse(res.data.result.shareScreen) : {};
              this.shareInfo = shareScreen;
              if (shareScreen.rtilCode) {
                const shareRtilCode = handleLocalStorage('get', 'shareCode');
                this.isShare = true;
                if (shareRtilCode) {
                  handleLocalStorage('set', 'shareCode', '');
                  this.cancalShareCommand(this.State.partyCode, shareScreen.rtilCode);
                }
              }
              if (res.data.result.crew) {
                Bus.$emit('setCrew', {
                  rtilCode: Number(res.data.result.crew)
                });
              }
              if (res.data.result.privateConversation) {
                Bus.$emit('startPrivateConversation', JSON.parse(res.data.result.privateConversation));
              }
            } else {
              if (this.ckeckStatusTimer) clearTimeout(this.ckeckStatusTimer);
              this.ckeckStatusTimer = setTimeout(() => {
                this.checkStatus();
              }, 1000);
            }
          } else {
            if (this.ckeckStatusTimer) clearTimeout(this.ckeckStatusTimer);
            setTimeout(() => {
              this.checkStatus();
            }, 1000);
          }
        }
      });
    },
    async subscribeTrack(payload) {
      if (!payload.id) return;
      console.info('subscribeTrack', payload.id, payload.channel, payload);
      if (this.talkInfo.rtilCode === payload.id) {
        this.talkStream = payload;
        return;
      }
      try {
        const {
          data: res
        } = await this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`);
        if (res.errorCode == '0x0') {
          if (this.outPutRtilCode && Number(this.outPutRtilCode) === payload.id) {
            const {
              id,
              videoTrack,
              audioTrack
            } = payload;
            if (!this.videoMedia[id]) {
              this.videoMedia[id] = new MediaStream();
            }
            this.$set(this.pgm, 'stream', this.videoMedia[id]);
            this.$set(this.pgm, 'id', id);
            if (videoTrack) {
              this.videoMedia[payload.id].addTrack(videoTrack._mediaStreamTrack);
              this.$set(this.pgm, 'videoTrack', videoTrack);
            }
            if (audioTrack) {
              this.videoMedia[payload.id].addTrack(audioTrack._mediaStreamTrack);
              this.$set(this.pgm, 'audioTrack', audioTrack);
            }
          } else {
            if (this.receiveAudioPartyList.includes(Number(payload.channel))) {
              const channel = this.dealPrivateChatChannel(payload);
              this.$set(this.receiveAudioArray, payload.id, channel);
            } else {
              const channel = this.dealPrivateChatChannel(payload);
              this.$set(this.channels, payload.id, {
                ...channel,
                tid: res.result.accountId,
                info: {
                  rtilCode: payload.id
                }
              });
            }
          }
          // 如果私聊是自己，需要mute掉没在和自己私聊的host的声音
          if (this.State.privateInfo.rtilCode == this.userInfo.rtilCode) {
            this.managerRtils.forEach(v => {
              if (v != this.State.privateInfo.crewRtilCode) {
                this.$set(this.controlMutes, v, true);
              } else {
                if (this.State.isMute) {
                  this.$set(this.controlMutes, v, true);
                } else {
                  this.$set(this.controlMutes, v, false);
                }
              }
            });
          }
          // 如果存在别人在私聊，则需要mute掉私聊的host声音
          if (this.State.privateInfoByOthers.length) {
            this.State.privateInfoByOthers.forEach(v => {
              if (v.rtilCode != this.userInfo.rtilCode) {
                this.$set(this.controlMutes, v.crewRtilCode, true);
              }
            });
          }
        }
      } catch (error) {}
    },
    removeView(payload) {
      const {
        id,
        channel
      } = payload;
      if (this.pgm.id == id) this.pgm = {};
      if (this.talkInfo.rtilCode === payload.id) this.talkStream = null;
      if (channel == this.externalParty) {
        this.$delete(this.receiveAudioArray, id);
      } else {
        this.$delete(this.channels, id);
      }
    },
    async joinPartyLine(newRealPartyCode) {
      if (this.socket) {
        this.socket.close(); // 手动停止websocket
        this.socket = null;
        if (this.updateInfoTimer) clearInterval(this.updateInfoTimer);
      }
      const rtilCode = await this.getBehaviorsByMemberId();
      const {
        id
      } = this.$route.query;
      // 初始化检查一次
      if (rtilCode) {
        if (this.behaviorInfo[rtilCode]) {
          // 有rtilCode代表设置过nickName
          if (newRealPartyCode) {
            setTimeout(() => {
              this.joinRequest(newRealPartyCode);
            }, 1000);
          } else {
            this.joinRequest(newRealPartyCode);
          }
        } else {
          // 直接通过join接口去添加nickName（新用户）
          routerJump('preview', {
            id
          });
        }
      } else {
        // 直接通过join接口去添加nickName（新用户）
        routerJump('preview', {
          id
        });
      }
    },
    async getBehaviorsByMemberId() {
      if (!this.State.partyCode) return;
      const params = {
        memberId: handleLocalStorage('get', 'galleryMemberId') || 'PL_' + new Date().getTime(),
        annotation: this.State.partyCode,
        keys: ['nickName']
      };
      handleLocalStorage('set', 'galleryMemberId', params.memberId);
      const res = await this.axios.post('/partyline-backend/behavior/noLogin/getListByMemberId', params);
      const result = res.data.result;
      const {
        rtilCode,
        behaviors
      } = result;
      if (res.data.errorCode == '0x0' && rtilCode) {
        this.behaviorInfo[rtilCode] = behaviors[rtilCode].nickName;
      }
      return rtilCode;
    },
    async joinRequest(newRealPartyCode, behaviors) {
      // 先离开其他的party再加入，
      for (const k in this.rtc) {
        if (this.rtc[k]) {
          await this.rtc[k].leave();
        }
      }
      this.bestOffset = 0;
      this.hasGetTimeOffset = false;
      const haveHistoryMem = handleLocalStorage('get', 'galleryMemberId');
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: this.State.partyCode,
        role: 0,
        type: 0,
        specifyPartyCode: newRealPartyCode || '',
        specifyRtilCode: newRealPartyCode ? +handleLocalStorage('get', 'rtilCode') : '',
        host: false,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'enableControlMedia', 'flipVideo']
      };
      if (behaviors) params.behaviors = behaviors;
      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        routeName: this.$route.query.from,
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.joinParam = {
            ...result,
            partyCode: this.State.partyCode,
            memberId: params.memberId
          };
          this.State.partyJoinInfo = result;
          addTabTitle({
            userInfo: result
          });
          this.$set(this.degreeHost, result.rtilCode, result.behavior.flipVideo);
          this.rtc[result.realPartyCode] = new AgoraRTCClient(this.callBack);
          this.devicesInfo = await this.rtc[result.realPartyCode].getDevice();
          this.userInfo = res.data.result;
          this.externalParty = result.externalJoinInfo.join;
          this.getSourceType(result.status.outputSource);
          this.layoutName = result.layoutName;
          this.State.groupLayout.layoutName = result.layoutName;
          this.freeTalk = false;
          result.status.volumeEffect === 0 ? this.audioLevel = true : this.audioLevel = false;
          if (this.layoutName == '2-2') {
            this.freeTalk = result.status.freeTalk == true;
          }

          // 自己是否在私聊
          if (result.status.privateConversation) {
            this.State.privateInfo = JSON.parse(result.status.privateConversation);
          } else {
            this.State.privateInfo = {};
          }

          // 是否存在别人在私聊
          if (!this.State.privateInfoByOthers.length) {
            if (result.status.privateConversations) {
              this.State.privateInfoByOthers = JSON.parse(result.status.privateConversations);
            } else {
              this.State.privateInfoByOthers = [];
            }
          }
          if (result.behavior && result.behavior.nickName) {
            const nickName = result.behavior.nickName;
            this.$set(this.behaviorInfo, this.userInfo.rtilCode, nickName);
            result.behavior.speaker = result.behavior.speaker !== 'false';
            result.behavior.camera = result.behavior.camera !== 'false';
            result.behavior.mic = result.behavior.mic !== 'false';
            this.joinAgoraClient(result, result.behavior, this.joinParam);
          }
          this.State.audioType = result.behavior.audioOnlyType ? Number(result.behavior.audioOnlyType) : 0;
          Bus.$emit('changeAudioTypeVal');
          Bus.$emit('changePartyAddress', {
            currentId: this.State.partyCode,
            title: result.title
          });
          // 控制与会者页面的重命名按钮
          result.status.lockName === 0 ? this.lockName = true : this.lockName = false;
          // 用于向别的组件传递初始化数据
          Bus.$emit('updateInitStatus', {
            hasCopy: result.status.hasCopy !== 0,
            loginButton: result.status.loginButton !== 0
          });
        } else if (res.data.errorCode === '80520103') {
          var _this$Config$urlInfo;
          const userServerUrl = (_this$Config$urlInfo = this.Config.urlInfo) === null || _this$Config$urlInfo === void 0 ? void 0 : _this$Config$urlInfo.userservice;
          const publicPath = this.State.publicPath || 'partyline';
          window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}?join_id=${this.partyCode}&serviceName=Partyline`;
        } else if (res.data.errorCode === '80520104') {
          routerJump('remove', {
            type: 'noCommonpartyPermission'
          });
        } else if (res.data.errorCode === '82201504') {
          routerJump('remove', {
            type: 'disableParty'
          });
        } else if (res.data.errorCode === '82201102') {
          // this.$message.error(this.$t('galleryParticipant.fullParticipatnes'))
          this.$message.error(res.data.errorInfo);
        } else if (res.data.errorCode === '80520113') {
          this.$message.error(this.$t('partyInfo.partyDisabled'));
        }
      }).catch(err => {
        console.info(err);
        if (err.status === 400) {
          this.$message.error(this.$t('remainWords.partyNotExist'));
          routerJump('joinPage');
        }
      });
    },
    joinAgoraClient(result, obj, param) {
      const {
        externalJoinInfo
      } = result;
      // 创建通知websocket
      if (!this.State.pageSerBusRequestWs[this.State.partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.$route.query.id
        });
      }
      // Me设置私聊功能，使用到
      this.MeInfo = {
        id: result.rtilCode,
        tid: handleLocalStorage('get', 'galleryMemberId'),
        info: {
          rtilCode: result.rtilCode
        },
        channel: this.partyCode
      };
      this.State.isMute = !obj.speaker;
      this.$set(this.State.cameraStatus, this.userInfo.rtilCode, obj.camera);
      this.$set(this.State.micStatus, this.userInfo.rtilCode, obj.mic);
      this.realPartyCode = result.realPartyCode;
      this.outPutRtilCode = String(result.status.output);
      this.State.outputCode = String(result.status.output);
      handleLocalStorage('set', 'rtilCode', result.rtilCode);
      this.managerRtils = result.managerRtils;
      // 延迟一秒执行是为了防止两channel有极少数的时候可能互相影响
      setTimeout(() => {
        this.joinChatParty(externalJoinInfo, result, obj);
      }, 1000);
      // join client
      this.getMeetingInfo(param, result, obj);
    },
    async callBack({
      action,
      payload
    }) {
      var _this$rtc$this$realPa4, _this$rtc$this$realPa5;
      const {
        changeDevice
      } = payload;
      switch (action) {
        case 'subscribe-track':
          console.info('subscribe-track', payload.id, payload.channel);
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          this.dealSubscribeVideo(payload);
          break;
        case 'user-joined':
          console.info(700, 'user-joined', payload.id, this.userInfo.managerRtils);
          // 手动添加host数据，用于chatList
          if (this.userInfo.managerRtils.includes(parseInt(payload.id))) {
            this.allPartyMembers.unshift(payload.id);
          }
          this.getNickName(payload.id);
          break;
        // 当远端用户发布了新的音视频轨道，此时可以订阅并播放远端用户所发布的音视频轨道
        case 'user-published':
          console.info(7001, 'user-published', payload.id);
          this.remoteStreamAdded(payload);
          this.muteAudioOrVideo(action, payload);
          break;
        case 'user-left':
          this.removeView(payload);
          break;
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload);
          break;
        case 'local-publish':
          if (payload.type.includes('audio')) {
            this.$set(this.State.micStatus, payload.id, true);
          }
          if (payload.type.includes('video')) {
            this.$set(this.State.cameraStatus, payload.id, true);
          }
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc || !this.rtc[this.realPartyCode]) return;
          this.devicesInfo = await this.rtc[this.realPartyCode].getDevice();
          if (this.rtc[this.realPartyCode]._localVideoTrack && changeDevice.device.label === this.rtc[this.realPartyCode]._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc[this.realPartyCode]._AgoraRTC.getCameras();
            (oldCameras === null || oldCameras === void 0 ? void 0 : oldCameras[0]) && this.rtc[this.realPartyCode].setDevice(oldCameras[0].deviceId, 'video', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
            });
          }
          break;
        case 'micChange':
          if (!this.rtc || !this.rtc[this.realPartyCode]) return;
          this.devicesInfo = await this.rtc[this.realPartyCode].getDevice();
          if (this.rtc[this.realPartyCode]._localAudioTrack && this.rtc[this.realPartyCode]._localAudioTrack._deviceName.includes(changeDevice.device.label) || changeDevice.state === 'INACTIVE' && ((_this$rtc$this$realPa4 = this.rtc[this.realPartyCode]._localAudioTrack) === null || _this$rtc$this$realPa4 === void 0 ? void 0 : _this$rtc$this$realPa4._config.microphoneId) == 'default') {
            const oldMic = await this.rtc[this.realPartyCode]._AgoraRTC.getMicrophones();
            (oldMic === null || oldMic === void 0 ? void 0 : oldMic[0]) && this.rtc[this.realPartyCode].setDevice(oldMic[0].deviceId, 'audio', type => {
              var _this$$refs$localAtte2;
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
              this.devicesInfo.microphoneId = oldMic[0].deviceId;
              (_this$$refs$localAtte2 = this.$refs.localAttentUser) === null || _this$$refs$localAtte2 === void 0 ? void 0 : _this$$refs$localAtte2.reAddAudioContext();
            });
          } else if (changeDevice.state === 'ACTIVE' && this.rtc[this.realPartyCode]._localAudioTrack && !this.rtc[this.realPartyCode]._localAudioTrack._deviceName.includes(changeDevice.device.label) && this.rtc[this.realPartyCode]._localAudioTrack._config.microphoneId != 'default') {
            var _this$$refs$localAtte3, _this$devicesInfo$mic;
            // 插入mic
            if (this.State.micStatus[this.userInfo.rtilCode]) {
              this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].setEnabled(false, 'audio');
              this.rtc[this.externalParty] && this.rtc[this.externalParty].setEnabled(false, 'audio');
              this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].setEnabled(true, 'audio');
              this.rtc[this.externalParty] && this.rtc[this.externalParty].setEnabled(true, 'audio');
            }
            (_this$$refs$localAtte3 = this.$refs.localAttentUser) === null || _this$$refs$localAtte3 === void 0 ? void 0 : _this$$refs$localAtte3.reAddAudioContext();
            if (((_this$devicesInfo$mic = this.devicesInfo.microphoneList) === null || _this$devicesInfo$mic === void 0 ? void 0 : _this$devicesInfo$mic[0].label) != this.rtc[this.realPartyCode]._localAudioTrack._deviceName) {
              this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
            }
          }
          break;
        case 'playbackChange':
          const rtc = this.rtc[this.realPartyCode];
          if (!rtc) return;
          if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
            this.$t('common.notSupportSwitchSpeaker');
            return;
          }
          if (changeDevice.state !== 'ACTIVE' && rtc._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const currentSpeakerList = await rtc._AgoraRTC.getPlaybackDevices();
            const haveUseDevice = currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice && currentSpeakerList !== null && currentSpeakerList !== void 0 && currentSpeakerList[0]) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo, _this$channels$rtilCo2;
                  (_this$channels$rtilCo = (_this$channels$rtilCo2 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.call(_this$channels$rtilCo2, currentSpeakerList[0].deviceId);
                }
              });
            }
          }
          this.devicesInfo = await rtc.getDevice();
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          this.$set(this.MeInfo, 'videoTrack', videoTrack);
          this.$set(this.MeInfo, 'audioTrack', audioTrack);
          if ((_this$rtc$this$realPa5 = this.rtc[this.realPartyCode]) !== null && _this$rtc$this$realPa5 !== void 0 && _this$rtc$this$realPa5._localAudioTrack) {
            const mediaStream = this.rtc[this.realPartyCode]._localAudioTrack._mediaStreamTrack;
            this.showMicMutedInfo.show = mediaStream.muted;
            mediaStream.onmute = () => {
              this.showMicMutedInfo.show = true;
            };
            mediaStream.onunmute = () => {
              this.showMicMutedInfo.show = false;
            };
          }
          break;
      }
    },
    async getMeetingInfo(param, result, behavior) {
      result = JSON.parse(JSON.stringify(result));
      const {
        outputSource,
        output,
        speaker
      } = result.status;
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = param;
      // 获取设备列表
      if (!handleLocalStorage('get', 'speakerId')) {
        handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
      }
      this.State.newPageLoading = false;
      const params = {
        appId,
        channel: realPartyCode + '',
        token: tokenCode,
        mode: 'live',
        codec: 'h264',
        uid: rtilCode,
        videoConfig: videoQualities,
        getRemoteNetworks: true,
        publish: !(outputSource == 'Participant' && output == rtilCode || speaker == rtilCode),
        // broadCast/speak在extral内发流
        publishAudio: behavior.mic,
        publishVideo: behavior.camera,
        video: !!this.devicesInfo.cameraId && this.State.cameraStatus[this.userInfo.rtilCode],
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[this.userInfo.rtilCode],
        subscribeRemote: false,
        cameraId: this.devicesInfo.cameraId,
        microphoneId: this.devicesInfo.microphoneId,
        startProxy: result.status.cloudProxy === 1
      };
      this.rtc[realPartyCode].join(params).then(async () => {
        var _this$rtc$realPartyCo2;
        this.hadOpenWebCloud = result.status.cloudProxy === 1;
        this.rtcLoaded = true;
        console.info('change and join new party', realPartyCode, this.rtc);
        this.rtilCode = rtilCode;
        this.partyCode = realPartyCode;
        this.State.currentRtilCode = rtilCode;
        this.checkStatus();
        // 判断是否有talk的状态
        const publicTalking = result.status.publicTalking;
        const raiseHandList = result.status.raiseHandList;
        if (publicTalking) {
          this.dealPublicTalking(publicTalking);
        }
        if (raiseHandList) {
          raiseHandList.forEach((item, index) => {
            if (this.rtilCode === item.rtilCode) {
              this.hasSetRaiseHand = true;
            }
          });
        }
        if (result.layoutName && result.layoutName.split('-')[0] >= 6) {
          var _this$rtc$realPartyCo;
          (_this$rtc$realPartyCo = this.rtc[realPartyCode]._client) === null || _this$rtc$realPartyCo === void 0 ? void 0 : _this$rtc$realPartyCo.enableDualStream(function () {});
        }
        setTimeout(() => {
          if (this.rtc[realPartyCode]._localVideoTrack) {
            this.rtc[realPartyCode].setSolution();
          }
        }, 2000);
        /// 更改hostjr userId
        const userId = rtilCode + '_' + this.behaviorInfo[this.MeInfo.id] + '_' + this.partyCode;
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
        ((_this$rtc$realPartyCo2 = this.rtc[realPartyCode]) === null || _this$rtc$realPartyCo2 === void 0 ? void 0 : _this$rtc$realPartyCo2._client) && this.rtc[realPartyCode]._client.enableAudioVolumeIndicator();
        if (!this.hasGetTimeOffset) {
          var _this$userInfo$videoQ, _this$userInfo$videoQ2;
          const offset = await this.dealTimeOffset();
          this.bestOffset = offset;
          this.hasGetTimeOffset = true;
          const fps = (_this$userInfo$videoQ = this.userInfo.videoQualities) === null || _this$userInfo$videoQ === void 0 ? void 0 : (_this$userInfo$videoQ2 = _this$userInfo$videoQ[0]) === null || _this$userInfo$videoQ2 === void 0 ? void 0 : _this$userInfo$videoQ2.fps;
          const intervalTime = fps ? Math.round(1000 / fps) : 33;
          if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
          this.sendMetadataTimer = setInterval(() => {
            this.sendMetadata();
          }, intervalTime);
        }
      });
    },
    async dealTimeOffset() {
      let bestRTT = Infinity;
      let bestOffset = 0;
      for (var i = 0; i < 10; i++) {
        const t0 = Date.now();
        const serverTime = await this.getTimeOffset();
        const t1 = Date.now();
        const rtt = t1 - t0;
        const offset = Date.now() - (serverTime + Math.round(rtt / 2));
        if (rtt < bestRTT) {
          bestRTT = rtt;
          bestOffset = offset;
        }
      }
      return bestOffset;
    },
    async getTimeOffset() {
      return await this.axios.get('/partyline-backend/base/getServerTime').then(res => {
        return res.data;
      });
    },
    sendMetadata() {
      var _this$rtc$this$userIn, _this$rtc$this$userIn2;
      if (!((_this$rtc$this$userIn = this.rtc[this.userInfo.realPartyCode]) !== null && _this$rtc$this$userIn !== void 0 && _this$rtc$this$userIn.hasJoined)) return;
      const params = {
        offset: this.bestOffset,
        rtilCode: this.userInfo.rtilCode,
        timestamp: Date.now() + this.bestOffset
      };
      (_this$rtc$this$userIn2 = this.rtc[this.userInfo.realPartyCode]._client) === null || _this$rtc$this$userIn2 === void 0 ? void 0 : _this$rtc$this$userIn2.sendMetadata(new TextEncoder().encode(JSON.stringify(params)), function (error) {
        if (error) console.log('sendMetadata', error);
      });
    },
    joinOtherParty(partyCode, newRealPartyCode) {
      const haveHistoryMem = handleLocalStorage('get', 'galleryMemberId');
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: partyCode,
        role: 0,
        type: 3,
        specifyPartyCode: newRealPartyCode || '',
        specifyRtilCode: newRealPartyCode ? +handleLocalStorage('get', 'rtilCode') : '',
        host: false
      };
      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        routeName: this.$route.query.from
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.joinParam = {
            ...result,
            partyCode: partyCode,
            memberId: params.memberId
          };
          this.joinNewAgoraClient(this.joinParam);
        } else if (res.data.errorCode === '82201504') {
          routerJump('remove', {
            type: 'disableParty'
          });
        }
      }).catch(err => {
        console.info(err);
        if (err.status === 400) {
          this.$message.error(this.$t('remainWords.partyNotExist'));
          routerJump('joinPage');
        }
      });
    },
    // 为了举手功能加的
    joinNewAgoraClient(param) {
      this.getNewMeetingInfo(param);
    },
    getNewMeetingInfo(param) {
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode
      } = param;
      const streamAdd = [];
      const params = {
        appID: appId,
        channel: realPartyCode + '',
        token: tokenCode,
        mode: 'live',
        codec: 'vp8',
        uid: rtilCode,
        audio: true,
        isPlay: true,
        subscribeRemote: false,
        streamAdd
      };
      if (this.rtc[realPartyCode]) this.rtc[realPartyCode].leave();
      this.rtc[realPartyCode] = new AgoraRTCClient();
      this.rtc[realPartyCode].join(params).then(() => {
        this.rtcLoaded = true;
      });
    },
    dealPublicTalking(publicTalking) {
      const info = JSON.parse(publicTalking);
      this.talkInfo = info;
      this.State.talkInfo = info;
      if (info.rtilCode === this.rtilCode) {
        this.hasBeenTalk = true;
        // 判断host所有的party的数量
        if (info.partyList.length > 1) {
          info.partyList.forEach((item, index) => {
            if (item != this.realPartyCode) {
              this.joinOtherParty(item);
            }
          });
        }
      } else {
        // 对于不是talk的 人来说只需要接收talk这路流就可以了
        const rtc = this.rtc[this.realPartyCode];
        // const stream = rtc.remoteAllStream[info.rtilCode]
        const stream = rtc._remotePublishUser[info.rtilCode];
        if (!stream) return;
        rtc.subscribe(info.rtilCode, 'all');
      }
    },
    createdWebsocket() {
      if (!this.$route.query.id || this.Config.urlInfo) return;
      const taskId = Tool.return32Str();
      const url = 'wss://' + this.Config.urlInfo.ccWebsocket + '/partyLineRequest?taskId=' + taskId + '&partyCode=' + this.realPartyCode + '&rtilCode=' + this.rtilCode + '&groupId=' + this.$route.query.id;
      const _self = this;
      this.socket = Tool.createWs(url);
      this.updateInfoTimer = setInterval(() => {
        if (_self.socket.client && _self.socket.client.readyState === 1) {
          const params = {
            type: 'listCurrentDevice',
            module: 'listCurrentDevice',
            data: {
              partyCode: this.partyCode,
              rtilCode: this.rtilCode
            }
          };
          _self.socket.send(params);
        }
      }, 5000);
    },
    // 改变网站声音
    changeMute(flag) {
      this.$store.dispatch('isMute', !this.isMute);
      this.managerRtils.forEach(id => {
        if (flag) {
          this.$set(this.controlMutes, id, true);
        } else {
          this.$set(this.controlMutes, id, false);
        }
      });
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      this.changeBehaviorStatus('speaker', !this.isMute);
    },
    async setCameraOrMic(type, val) {
      this.hasSet = true;
      if (type === 'muteVideo') {
        if (!this.State.hasVideo) {
          this.State.guideObjShow = true;
          return;
        }
        if (val) {
          // 打开摄像头
          this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].setEnabled(true, 'video');
          this.rtc[this.externalParty] && this.rtc[this.externalParty].setEnabled(true, 'video');
        } else {
          // 关闭摄像头
          this.rtc[this.realPartyCode] && this.rtc[this.realPartyCode].setEnabled(false, 'video');
          this.rtc[this.externalParty] && this.rtc[this.externalParty].setEnabled(false, 'video');
        }
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'camera',
          value: val,
          partyCode: this.userInfo.joinCode,
          toRtilCode: this.userInfo.rtilCode
        });
      } else {
        if (!this.State.hasAudio) {
          this.State.guideObjShow = true;
          return;
        }
        let operationResult = 'success';
        const type = val ? 'publish' : 'unpublish';
        if (val) {
          const rtc = this.rtc[this.realPartyCode];
          if (rtc && rtc._localAudioTrack) {
            operationResult = await controlDevicePublish(rtc, type, [rtc._localAudioTrack]);
            if (this.speakerInfo && this.speakerInfo.rtilCode == this.userInfo.rtilCode || this.broadCast && this.broadCast.rtilCode == this.userInfo.rtilCode) {
              if (this.rtc[this.externalParty]) {
                await controlDevicePublish(this.rtc[this.externalParty], type, [this.rtc[this.externalParty]._localAudioTrack]);
              }
            }
          } else {
            controlAudio(rtc, this.devicesInfo, val, result => {
              if (result == 'failed') operationResult = 'failed';
            });
            if (this.speakerInfo && this.speakerInfo.rtilCode == this.userInfo.rtilCode || this.broadCast && this.broadCast.rtilCode == this.userInfo.rtilCode) {
              controlAudio(rtc, this.devicesInfo, val, result => {
                if (result == 'failed') operationResult = 'failed';
              });
            }
          }
        } else {
          // 关闭麦克风
          Object.keys(this.rtc).forEach(async v => {
            if (!this.rtc[v]._localAudioTrack) return;
            operationResult = await controlDevicePublish(this.rtc[v], 'unpublish', [this.rtc[v]._localAudioTrack]);
          });
        }
        if (operationResult === 'success') {
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: this.userInfo.joinCode,
            toRtilCode: this.userInfo.rtilCode,
            origin: 'GalleryViewParticipant'
          });
        }
      }
    },
    changeBehaviorStatus(key, value) {
      if (this.userInfo.rtilCode && this.$route.query.id) {
        // 更新状态
        const params = [{
          mark: this.userInfo.rtilCode + '',
          annotation: this.$route.query.id,
          key,
          value
        }];
        this.axios.post('/partyline-backend/behavior/noLogin/setList', params);
      }
    },
    // 离开会议
    showDialog() {
      Bus.$emit('showDialog', {
        show: true,
        realPartyCode: this.partyCode,
        externalParty: this.externalParty,
        rtilCode: this.userInfo.rtilCode
      });
    },
    // 为了所有host可以聊天加的,单独写是不想之前的逻辑太混乱
    joinChatParty(externalJoinInfo, result, behavior) {
      this.receiveAudioPartyList = [];
      const party = externalJoinInfo.externalPartyInfo;
      party.forEach(item => {
        this.receiveAudioPartyList.push(item.externalParty);
        const param = {
          ...item.joinInfo,
          partyCode: item.joinInfo.realPartyCode
        };
        this.getChatMeetingInfo(param, result, behavior);
      });
    },
    getChatMeetingInfo(param, result, behavior) {
      const {
        outputSource,
        output,
        nickName
      } = result.status;
      const {
        appId,
        tokenCode,
        rtilCode,
        partyCode,
        videoQualities
      } = param;
      const isBroadCaster = outputSource == 'Participant' && output == rtilCode;
      const isSpeaker = result.status.speaker == rtilCode;
      const codec = this.layoutName === '2-4' ? 'h264' : 'vp8';
      const params = {
        appId: appId,
        channel: partyCode + '',
        token: tokenCode,
        mode: 'live',
        codec,
        uid: rtilCode,
        domId: 'sendVideo',
        video: !!this.devicesInfo.cameraId && this.State.cameraStatus[this.userInfo.rtilCode],
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[this.userInfo.rtilCode],
        isPlay: !this.isPhone,
        videoConfig: videoQualities,
        subscribeRemote: true,
        publishAudio: behavior.mic && (isBroadCaster || isSpeaker),
        publishVideo: behavior.camera && isBroadCaster,
        cameraId: this.devicesInfo.cameraId,
        microphoneId: this.devicesInfo.microphoneId,
        executeLocalSubscribe: true
      };
      // id更换channel
      this.rtc[partyCode] = new AgoraRTCClient(this.callBack);
      this.rtc[partyCode].join(params).then(() => {
        this.rtcLoaded = true;
        if (result.status.outputSource == 'Participant') {
          this.broadCast = {
            rtilCode: result.status.output,
            nickName
          };
          if (result.status.output == result.rtilCode) {
            // 加延迟是为了初始化的时候不会因为还没有流而导致视频不显示
            setTimeout(() => {
              this.subscribePgmStream(rtilCode, result.externalJoinInfo.join, 'setOutput');
            }, 1000);
          }
        }
        setTimeout(() => {
          if (this.rtc[partyCode]._localVideoTrack) {
            this.rtc[partyCode].setSolution();
          }
        }, 2000);
        if (result.status.speaker) {
          this.speakerInfo = {
            rtilCode: result.status.speaker,
            nickName: result.status.speakerNickName
          };
        }
      });
    },
    subscribePgmStream(rtilCode, key, setOutput) {
      if (!this.videoMedia[rtilCode]) {
        this.videoMedia[rtilCode] = new MediaStream();
      }
      this.$set(this.pgm, 'stream', this.videoMedia[rtilCode]);
      this.$set(this.pgm, 'id', rtilCode);
      if (this.rtc[key]) {
        if (this.rtc[key]._localAudioTrack) {
          this.videoMedia[rtilCode].addTrack(this.rtc[key]._localAudioTrack._mediaStreamTrack);
          this.$set(this.pgm, 'audioTrack', this.rtc[key]._localAudioTrack);
        }
        if (this.rtc[key]._localVideoTrack) {
          this.videoMedia[rtilCode].addTrack(this.rtc[key]._localVideoTrack._mediaStreamTrack);
          this.$set(this.pgm, 'videoTrack', this.rtc[key]._localVideoTrack);
          if (setOutput) this.$set(this.pgm, 'showLocal', true);
        }
      }
    },
    subscribeRemotePgmStream(rtilCode, stream) {
      if (!this.videoMedia[rtilCode]) {
        this.videoMedia[rtilCode] = new MediaStream();
      }
      this.$set(this.pgm, 'stream', this.videoMedia[rtilCode]);
      this.$set(this.pgm, 'id', rtilCode);
      if (stream) {
        if (stream.audioTrack) {
          this.videoMedia[rtilCode].addTrack(stream.audioTrack._mediaStreamTrack);
          this.$set(this.pgm, 'audioTrack', stream.audioTrack);
        } else if (stream.videoTrack) {
          this.videoMedia[rtilCode].addTrack(stream.videoTrack._mediaStreamTrack);
          this.$set(this.pgm, 'videoTrack', stream.videoTrack);
        }
      }
    },
    dealPrivateChatChannel(payload) {
      const {
        id,
        videoTrack,
        audioTrack
      } = payload;
      if (!this.videoMedia[id]) {
        this.videoMedia[id] = new MediaStream();
      }
      if (videoTrack) {
        this.videoMedia[payload.id].addTrack(videoTrack._mediaStreamTrack);
      }
      if (audioTrack) {
        this.videoMedia[payload.id].addTrack(audioTrack._mediaStreamTrack);
      }
      const channel = {
        stream: this.videoMedia[id],
        id: id,
        videoTrack: videoTrack,
        audioTrack: audioTrack
      };
      return channel;
    },
    setLowStreamParameter(lowStreamParameter) {
      var _this$rtc$this$realPa6;
      (_this$rtc$this$realPa6 = this.rtc[this.realPartyCode]._client) === null || _this$rtc$this$realPa6 === void 0 ? void 0 : _this$rtc$this$realPa6.setLowStreamParameter(lowStreamParameter);
    }
  },
  mounted() {
    const {
      id
    } = this.$route.query;
    if (id) {
      setTimeout(() => {
        this.joinPartyLine();
      }, 1000);
    }
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
  },
  async beforeRouteLeave(to, from, next) {
    for (const k in this.rtc) {
      this.rtc[k] && (await this.rtc[k].leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : ''));
    }
    Bus.$off('initDevices');
    for (const k in this.rtc) {
      this.rtc[k] && this.rtc[k].leave();
    }
    this.socket && this.socket.close();
    if (this.updateInfoTimer) clearInterval(this.updateInfoTimer);
    this.State.crewInfo = {};
    this.State.privateInfo = {};
    if (this.ckeckStatusTimer) clearTimeout(this.ckeckStatusTimer);
    if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
    this.shareRtc && this.shareRtc.leave();
    if (this.State.pageSerBusRequestWs[this.State.partyCode]) {
      this.State.pageSerBusRequestWs[this.State.partyCode].close(); // 手动停止websocket
      this.State.pageSerBusRequestWs[this.State.partyCode] = null;
    }
    next();
  }
};